import { render } from "./GreenDetail.vue?vue&type=template&id=d2cd4494"
import script from "./GreenDetail.vue?vue&type=script&lang=js"
export * from "./GreenDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__